module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3"
  }, [_c('h3', {
    staticClass: "bg-faded mt-3 pt-3 pb-3 "
  }, [_vm._v("使用vue-cli脚手架搭建项目")]), _vm._v(" "), _c('h5', [_vm._v("一、介绍")]), _vm._v(" "), _c('h6', [_vm._v("关于vue.js")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_vm._v("vue.js是一套构建用户界面的 轻型的渐进式前端框架。它的目标是通过尽可能简单的 API 实现响应的数据绑定和组合的视图组件。使用vue可以给你的开发带来极致的编程体验。")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_vm._v("参考地址："), _c('a', {
    attrs: {
      "href": "http://doc.vue-js.com/v2/guide/"
    }
  }, [_vm._v("http://doc.vue-js.com/v2/guide/")])]), _vm._v(" "), _c('h6', [_vm._v("关于vue-cli ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_vm._v("Vue-cli是vue官方提供的一个命令行工具（vue-cli），可用于快速搭建大型单页应用。该工具提供开箱即用的构建工具配置，带来现代化的前端开发流程。只需一分钟即可启动带热重载、保存时静态检查以及可用于生产环境的构建配置的项目。")]), _vm._v(" "), _c('h5', [_vm._v("二、Node.js安装")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('a', {
    attrs: {
      "href": "http://nodejs.cn/download/"
    }
  }, [_vm._v("http://nodejs.cn/download/ ")])]), _vm._v(" "), _c('h5', [_vm._v("三、安装vue-cli")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('kbd', [_vm._v("npm install -g vue-cli")])]), _vm._v(" "), _c('h5', [_vm._v("四、使用vue-cli初始化项目")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('kbd', [_vm._v("vue init webpack my-project")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "static/blog/1/QQ20170624-0.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("五、进到项目目录下")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('kbd', [_vm._v("cd my-project")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "static/blog/1/QQ20170624-1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("六、安装依赖")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('kbd', [_vm._v("npm install")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "static/blog/1/QQ20170624-2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_vm._v("\n        安装成功\n    ")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "static/blog/1/QQ20170624-3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("七、启动项目")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('kbd', [_vm._v("npm run dev")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "static/blog/1/QQ20170624-4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("八、打包上线")]), _vm._v(" "), _c('p', {
    staticClass: "pl-3"
  }, [_c('kbd', [_vm._v("npm run build")])]), _vm._v(" "), _c('p', [_vm._v("生成的静态文件默认在dist目录下")]), _vm._v(" "), _c('h5', [_vm._v("九、项目结构")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "static/blog/1/QQ20170624-5.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("详情参见："), _c('a', {
    attrs: {
      "href": "https://segmentfault.com/a/1190000007880723"
    }
  }, [_vm._v("https://segmentfault.com/a/1190000007880723")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-487c0b6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog/vue-init.vue
// module id = 599
// module chunks = 2